/**
 * @flow
 */

import {
  ON_MY_PASSES_MOUNT,
  ON_MY_PASSES_MOUNT_SUCCESS,
  TOGGLE_PASS_OPEN,
  TOGGLE_PASS_CLOSED,
  ON_TOGGLE_PASS_SUCCESS
} from '../actions';

const initialState = [];

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_MY_PASSES_MOUNT_SUCCESS:
      return action.payload;

    case ON_MY_PASSES_MOUNT:
      return [];

    case TOGGLE_PASS_OPEN:
      const passes = state.passes.map(pass => {
        if (pass.id === action.payload.id) {
          pass.expanded = true;
          pass.loading = true;
          return pass;
        }

        pass.expanded = false;
        return pass;
      });

      return Object.assign({}, state, {
        passes
      });

    case TOGGLE_PASS_CLOSED:
      const closedPasses = state.passes.map(pass => {
        if (pass.id === action.payload.id) {
          pass.expanded = false;
          pass.loading = false;
          return pass;
        }

        return pass;
      });

      return Object.assign({}, state, { closedPasses });

    case ON_TOGGLE_PASS_SUCCESS:
      const updatedPasses = state.passes.map(pass => {
        if (pass.expanded) {
          pass.listingsForThisPass = action.payload;
          pass.loading = false;
        }
      });

      return Object.assign({}, state, { updatedPasses });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/my-tickets/reducers/passes.js